import { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { wikiSearchStyle } from './WikiSearch.style'
import { TextField } from '@material-ui/core'

/**
 * WikiSearchComponentProps contains properties for the component.
 */
export interface WikiSearchComponentProps {
  onInputChange: (input: string) => void
  onClose?: () => void
}

/**
 * WikiSearchComponent displays wiki search field
 * @param props Properties for component.
 * @returns JSX component.
 */
export const WikiSearchComponent: FC<WikiSearchComponentProps> = ({ onInputChange, onClose = () => {} }: WikiSearchComponentProps) => {
  const classes = wikiSearchStyle()
  const intl = useIntl()

  useEffect(() => {
    const handleKeyDown = (e: Event): void => {
      if (((e as unknown) as KeyboardEvent).key === 'Escape') {
        onClose()
      }
    }
    document.addEventListener('keydown', handleKeyDown, false)
    return () => {
      document.removeEventListener('keydown', handleKeyDown, false)
    }
  }, [onClose])

  return (
    <div className={classes.root}>
      <div className={classes.triangle} />
      <TextField
        className={classes.searchField}
        label={intl.formatMessage({ id: 'common.search' })}
        variant='outlined'
        size='small'
        autoFocus
        onChange={e => onInputChange(e.target.value)}
      />
    </div>
  )
}

export default WikiSearchComponent
